import React from "react";

export const FormTextArea = ({
  register,
  error,
  label,
  id,
  isRequired,
  //Consigna visible debajo del label (antes vivía solo en el placeholder de
  //los textareas largos y desaparecía al empezar a escribir).
  ayuda,
  ...inputProps
}) => {
  const errorId = `${id}-error`;
  const ayudaId = `${id}-ayuda`;
  const describedBy =
    [ayuda ? ayudaId : null, error ? errorId : null].filter(Boolean).join(" ") ||
    undefined;
  return (
    <div className="form-group">
      <label htmlFor={id}>{label}</label>
      {ayuda && (
        <small id={ayudaId} className="form-text text-muted mb-1">
          {ayuda}
        </small>
      )}
      <textarea
        {...register(id, { required: isRequired })}
        className={`form-control ${error ? "is-invalid" : ""}`}
        id={id}
        aria-required={isRequired || undefined}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy}
        {...inputProps}
      />
      {error && (
        <small id={errorId} className="text-danger form-text">
          {error.message || "Campo Obligatorio."}
        </small>
      )}
    </div>
  );
};

export default FormTextArea;
